import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/OEMsInColomboPage.css";

// Logo Slider – shows 2 logos per slide
// Logo Slider
// Logo Slider
const LogoSlider = ({ images }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [mobileLogoIndex, setMobileLogoIndex] = useState(0);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();

    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (!isMobile || !images || images.length === 0) return;

    const timer = setInterval(() => {
      setMobileLogoIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [isMobile, images]);

  if (!images || images.length === 0) return null;

  const nextLogo = () => {
    setMobileLogoIndex((prev) => (prev + 1) % images.length);
  };

  const prevLogo = () => {
    setMobileLogoIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    pauseOnHover: true,
  };

  return isMobile ? (
    <div className="mobile-oem-slider">
      <button type="button" className="mobile-oem-arrow left" onClick={prevLogo}>
        ‹
      </button>

      <div className="mobile-oem-logo">
        <img src={images[mobileLogoIndex]} alt="OEM logo" />
      </div>

      <button type="button" className="mobile-oem-arrow right" onClick={nextLogo}>
        ›
      </button>
    </div>
  ) : (
    <div className="logo-slider">
      <Slider {...settings}>
        {images.map((img, idx) => (
          <div key={idx} className="logo-slide">
            <img src={img} alt={`Logo ${idx + 1}`} />
          </div>
        ))}
      </Slider>
    </div>
  );
};
// Section component – two columns with independent backgrounds
const Section = ({ textContent, media, mediaType, textFirst = false }) => {
  // Text column always dark, media column always light
  const TextColumn = () => (
    <div
      className="col-text bg-dark"
      data-aos={textFirst ? "fade-right" : "fade-left"}
    >
      <div className="col-inner">{textContent}</div>
    </div>
  );
  const MediaColumn = () => (
    <div
      className="col-media bg-light"
      data-aos={textFirst ? "fade-left" : "fade-right"}
    >
      <div className="col-inner">
        {mediaType === "image" && <img src={media} alt="OEM" />}
        {mediaType === "slider" && <LogoSlider images={media} />}
      </div>
    </div>
  );

  return (
    <div className="section-row">
      <div className="section-container">
        {textFirst ? (
          <>
            <TextColumn />
            <MediaColumn />
          </>
        ) : (
          <>
            <MediaColumn />
            <TextColumn />
          </>
        )}
      </div>
    </div>
  );
};

const OEMsInColomboPage = () => {
  // Logo slider image arrays
  const slider1 = [
    "/wp-content/uploads/2016/04/logo5.jpg",
    "/wp-content/uploads/2016/04/logo7.jpg",
    "/wp-content/uploads/2016/04/logo20.jpg",
    "/wp-content/uploads/2016/04/logo27.jpg",
    "/wp-content/uploads/2016/04/logo28.jpg",
    "/wp-content/uploads/2016/04/logo3.jpg",
  ];
  const slider2 = [
    "/wp-content/uploads/2016/04/logo1.jpg",
    "/wp-content/uploads/2016/04/logo2.jpg",
    "/wp-content/uploads/2016/04/logo21.jpg",
    "/wp-content/uploads/2016/04/logo22.jpg",
    "/wp-content/uploads/2016/04/logo13.jpg",
  ];
  const slider3 = [
    "/wp-content/uploads/2016/04/logo6.jpg",
    "/wp-content/uploads/2016/04/logo9.jpg",
    "/wp-content/uploads/2016/04/logo12.jpg",
    "/wp-content/uploads/2016/04/logo17.jpg",
    "/wp-content/uploads/2016/04/logo24.jpg",
  ];
  const slider4 = [
    "/wp-content/uploads/2016/04/logo10.jpg",
    "/wp-content/uploads/2025/01/ABS.jpg",
    "/wp-content/uploads/2016/04/logo15.jpg",
    "/wp-content/uploads/2016/04/logo16.jpg",
    "/wp-content/uploads/2016/04/logo19.jpg",
    "/wp-content/uploads/2016/04/logo30.jpg",
    "/wp-content/uploads/2016/04/logo31.jpg",
    "/wp-content/uploads/2016/04/logo32.jpg",
  ];

  // Text content
  const textMan = (
    <>
      <h2>
        <strong>Man Diesel & Turbo SE,</strong>
      </h2>
      <h4>
        <strong>Augsburg Germany</strong>
      </h4>
      <p>&nbsp;</p>
      <p>
        MAN has recently established an office in Colombo which is headed by a
        GM from Germany and includes a full-time service engineer. MAN is in the
        process of developing their own facility and assists us with spare parts
        and service engineer requirements.
      </p>
    </>
  );

  const textSiemens = (
    <>
      <h2>
        <strong>
          Siemens Ltd, Bosch, Detroit MTU, Atlas Copco, Ingersoll-Rand, Thordon,
          Schneider
        </strong>
      </h2>
      <p>&nbsp;</p>
      <p>
        Makes available trained technicians and maintains an approved workshop
        in Colombo.
      </p>
    </>
  );

  const textWartsila = (
    <>
      <h2>
        <strong>Wartsila,</strong>
      </h2>
      <h4>
        <strong>Finland</strong>
      </h4>
      <p>&nbsp;</p>
      <p>
        Wartsila has maintained a fully equipped workshop and office in Colombo
        since 2005 and has trained engineers in the following specialities:
      </p>
      <ul>
        <li>Two stroke and four stroke engines</li>
        <li>Woodward governor servicing</li>
        <li>Shaft seal bonding</li>
        <li>CPP/FPP propeller blade repairs/Super polishing and balancing</li>
      </ul>
    </>
  );

  const textBridge = (
    <>
      <h2>
        <strong>Bridge Navigation and Radio Equipment</strong>
      </h2>
      <h4>
        <strong>The following OEM’s are represented in Colombo</strong>
      </h4>
      <p>&nbsp;</p>
      <p>
        Furuno Electric Co.Ltd., Japan Radio Co.Ltd., Tokyo Keiki, Koden,
        Yokogawa, Kelvin Hughes UK Ltd., Icom, Samyung/Korea, Raytheon Anschutz/
        Germany are represented by agents maintaining service teams and spares.
      </p>
      <p>
        Also the following manufacturing companies are approved for SVDR/VDR,
        APT; Kelvin Hughes/Japan, Ruttel Technologies Incorporation/Canada,
        Netherland. In addition to the above, Thrane & Thrane, Simrad, Skipper,
        Skanti, Sperry, Sailor, Imcos, C-Plath, Navico and Deca products are
        also available.
      </p>
    </>
  );

  const textABB = (
    <>
      <h2>
        <strong>ABB Ltd</strong>
      </h2>
      <p>&nbsp;</p>
      <p>
        ABB has maintained a fully fledged service outlet since 2004 with a
        workshop and trained service engineers who can assist with overhauls,
        ash blasting, balancing, and re-blading of ABB/BBC/IHI charges.
      </p>
    </>
  );

  const textPaint = (
    <>
      <h2>
        <strong>Marine paint Suppliers</strong>
      </h2>
      <p>&nbsp;</p>
      <p>
        Reputed marine paint suppliers to our workshops include PPG Coatings,
        Akzo-Nobel, Hempel, Chugoku, and Jotun.
      </p>
    </>
  );

  const textCaterpillar = (
    <>
      <h2>
        <strong>Caterpillar/MAK</strong>
      </h2>
      <p>&nbsp;</p>
      <p>
        Caterpillar maintains a fully fledged workshop with trained service
        engineers.
      </p>
    </>
  );

  const textClassification = (
    <>
      <h2>
        <strong>Classification Societies represented in Sri Lanka</strong>
      </h2>
      <p>
        DNV-GL, LR, BV, NK, ABS, IRS, RINA, and INSB maintain full-time offices
        in Colombo, manned by professional surveyors.
      </p>
    </>
  );

  const textCummins = (
    <>
      <h2>
        <strong>Cummins</strong>
      </h2>
      <p>&nbsp;</p>
      <p>
        Cummins maintains a fully fledged workshop with trained service
        engineers.
      </p>
    </>
  );

  return (
    <div className="oems-page">
      <Header />
      <section
        className="banner-header"
        style={{
          backgroundImage:
            "url('/wp-content/uploads/2016/04/Executive-Valour-.jpg')",
        }}
      ></section>
      <section className="contentwrapper clearfix">
        {/* Centered breadcrumb and title */}
        <div className="content-header">
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>OEM’S in Colombo</span>
          </div>
          <h1 data-aos="fade-right">OEM’S in Colombo</h1>
        </div>

        {/* Full‑width sections */}
        <Section
          textContent={textMan}
          media="/wp-content/uploads/2016/04/logo.png"
          mediaType="image"
          textFirst={true}
        />
        <Section
          textContent={textSiemens}
          media={slider1}
          mediaType="slider"
          textFirst={false}
        />
        <Section
          textContent={textWartsila}
          media="/wp-content/uploads/2016/04/Wartsila.png"
          mediaType="image"
          textFirst={true}
        />
        <Section
          textContent={textBridge}
          media={slider2}
          mediaType="slider"
          textFirst={false}
        />
        <Section
          textContent={textABB}
          media="/wp-content/uploads/2016/04/ABB-Logo.png"
          mediaType="image"
          textFirst={true}
        />
        <Section
          textContent={textPaint}
          media={slider3}
          mediaType="slider"
          textFirst={false}
        />
        <Section
          textContent={textCaterpillar}
          media="/wp-content/uploads/2016/04/Caterpiller-logo.png"
          mediaType="image"
          textFirst={true}
        />
        <Section
          textContent={textClassification}
          media={slider4}
          mediaType="slider"
          textFirst={false}
        />
        <Section
          textContent={textCummins}
          media="/wp-content/uploads/2016/04/logo-1.png"
          mediaType="image"
          textFirst={true}
        />
      </section>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default OEMsInColomboPage;
